export default "__VITE_ASSET__B895At77__"